import { useEffect, useState } from 'react'
import './stationDownloads.css'

const command = "file=$(mktemp) && curl --fail --show-error --location --proto '=https' https://spectraguardai.com/spectra-remote-install.sh -o \"$file\" && bash \"$file\"; rm -f \"$file\""

export function StationDownloads() {
  const [message, setMessage] = useState('')
  const [localRelease, setLocalRelease] = useState<{ version: string; url: string } | null>(null)
  useEffect(() => {
    const controller = new AbortController()
    fetch('/local-offline/update.json', { cache: 'no-store', signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error('release_unavailable'); return response.json() })
      .then((release: { version: string; url: string }) => {
        const url = new URL(release.url, location.origin)
        if (!/^\d+\.\d+\.\d+$/.test(release.version) || url.origin !== location.origin || !url.pathname.startsWith('/local-offline/pilot-')) return
        setLocalRelease({ version: release.version, url: url.pathname })
      }).catch(() => {})
    return () => controller.abort()
  }, [])
  async function copy() {
    try { await navigator.clipboard.writeText(command); setMessage('Comando copiado.') }
    catch { setMessage('Selecione e copie o comando abaixo.') }
  }
  return <section className="station-downloads" aria-label="Downloads para estações">
    <article><h3>Local Offline para Windows</h3><p>{localRelease ? `Versão ${localRelease.version} • ` : ''}Windows 64 bits. Organize câmeras e perfis de mosaico na rede local.</p><a href={localRelease?.url ?? '/local-offline/latest/SpectraLocalOffline-Setup.exe'} download>Baixar Local Offline{localRelease ? ` ${localRelease.version}` : ' — versão mais recente'}</a></article>
    <article><h3>Spectra Remote para Raspberry Pi</h3><p>Raspberry Pi OS 64 bits, com desktop Wayland/labwc. Abra o terminal no Raspberry e cole o comando para instalar.</p><a href="/downloads/remote/linux/spectra-remote-linux-arm64-pilot-b8106bfffa26.tar.gz" download>Baixar pacote ARM64</a><button type="button" onClick={() => void copy()}>Copiar comando de instalação</button><pre tabIndex={0}><code>{command}</code></pre><small role="status">{message}</small></article>
  </section>
}
